import { Modal } from "antd";
const { confirm } = Modal;

export { default } from "./Modal";
export { confirm };
